import type { AppSpecData } from '@wix/thunderbolt-symbols'

/**
 * @description - find all legacy builder components according to client spec map componentType:
 * Legacy components are:
 * - TPAWidget
 * - TPAGluedWidget
 * - TPASection
 * - TPAMultiSection
 * @param isBuilderComponentModel - BuilderComponentModel flag
 * @param clientSpecMap - client spec map
 * @returns builder legacy components map
 */
export const getBuilderLegacyComponentsMap = (
	isBuilderComponentModel: boolean,
	clientSpecMap: Record<string, AppSpecData>,
): BuilderLegacyComponentsMap => {
	const result: BuilderLegacyComponentsMap = {}

	if (!isBuilderComponentModel) {
		return {}
	}

	for (const spec of Object.values(clientSpecMap)) {
		if (!spec.widgets) {
			continue
		}

		for (const widget of Object.values(spec.widgets)) {
			const { componentType, refType } = widget.componentFields || {}

			if (componentType !== undefined && refType !== undefined) {
				result[componentType] = refType
			}
		}
	}

	return result
}

export type BuilderLegacyComponentsMap = Record<string, string>
